import { Component, computed, input } from '@angular/core';
import { ICONS } from './icons';

@Component({
  selector: 'pec-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  host: {
    '[style.font-size]': 'size() ? size() + "px" : null',
  },
})
export class IconComponent {
  name = input<string>('');
  size = input<number>(0);
  paths = computed(() => ICONS[this.name()] ?? ICONS['circle']);
}
